/**
 * VirtualRobot への再生要求を識別する単調増加 ID。
 * Date.now() だと同一ミリ秒で衝突するためカウンタを使う。
 */
let flowRequestSeq = 0;

export const nextFlowRequestId = (): number => {
  flowRequestSeq += 1;
  return flowRequestSeq;
};

